import { z } from '@uturn/portal/zod';

const selectableContainerTypeSchema = z.object({
	id: z.number(),
	code: z.string(),
	description: z.string(),
	portbaseCode: z.string().optional(),
	containerRequired: z.boolean().optional(),
	generatorSetRequired: z.boolean().optional(),
	disabled: z.boolean().optional(),
});

export type SelectableContainerType = z.infer<
	typeof selectableContainerTypeSchema
>;

export const isSelectableContainerType = (
	data: unknown,
): data is SelectableContainerType =>
	selectableContainerTypeSchema.safeParse(data).success;
